import { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./author.css";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { BaseUrl } from "../../helper/BaseUrl";
import { toast } from "react-toastify";

const authorEditEndpoint = ApiEndpoints.autor.authorEdit;
const authorUpdateEndPoint = ApiEndpoints.autor.authorUpdate;

export default function EditAuthor() {
  const { author_id } = useParams();
  const navigate = useNavigate();

  const [previewImage, setPreviewImage] = useState("");

  // Consolidate data into a single state object
  const [formData, setFormData] = useState({
    name: "",
    designation: "",
    description: "",
    image: null,
    facebook: "",
    linkedin: "",
    instagram: "",
  });

  // Fetch the existing author data
  useEffect(() => {
    const dataFetch = async () => {
      try {
        const response = await ApiRequest(
          "GET",
          `${authorEditEndpoint}${author_id}`
        );
        const result = response.author;
        setFormData({
          name: result.name || "",
          designation: result.designation || "",
          description: result.description || "",
          image: null, // Image should be updated via new upload
          facebook: result.facebook || "",
          linkedin: result.linkedin || "",
          instagram: result.instagram || "",
        });

        setPreviewImage(result.image ? `${BaseUrl}/${result.image}` : "");
      } catch (error) {
        console.error("Error fetching author data:", error);
      }
    };
    dataFetch();
  }, [author_id]);

  // Handle changes to form inputs
  const handleChange = useCallback((event) => {
    const { name, value, type, files } = event.target;

    if (name === "image" && type === "file") {
      const file = files[0];
      if (file) {
        const objectUrl = URL.createObjectURL(file);
        setPreviewImage(objectUrl);
      }
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "file" ? files[0] : value,
    }));
  }, []);

  // Handle form submission
  const handleSubmit = useCallback(
    async (event) => {
      event.preventDefault();

      // Create a new FormData instance
      const payload = new FormData();

      // Add all form fields except the image
      Object.keys(formData).forEach((key) => {
        if (key !== "image") {
          payload.append(key, formData[key]);
        }
      });

      // Append the image field if it exists
      if (formData.image) {
        payload.append("image", formData.image);
      }

      // Add author_id to the payload
      payload.append("author_id", author_id);

      try {
        // Send the API request with the FormData payload
        const response = await ApiRequest("POST", authorUpdateEndPoint, payload, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        toast.success(response.message)
        navigate("/admin/author");
      } catch (error) {
        console.error("Error updating author:", error);
      }
    },
    [author_id, formData, navigate]
  );


  return (
    <>
      <div className="header-add-category">
        <h5>Edit Author</h5>
      </div>
      <div className="add-author-content">
        <form onSubmit={handleSubmit}>
          <label>Name:*</label>
          <input name="name" value={formData.name} type="text" className="form-control" onChange={handleChange} required />

          <label>Designation:*</label>
          <input name="designation" value={formData.designation} type="text" className="form-control" onChange={handleChange} required />

          <label>Description:*</label>
          <textarea name="description" value={formData.description} className="form-control" onChange={handleChange} required />

          <label>Image:(112X112 px)</label>
          <input name="image" type="file" className="form-control" onChange={handleChange} />
          {previewImage && (
            <div style={{ width: "60px", height: "60px", margin: "10px 0", overflow: "hidden" }}>
              <img src={previewImage} alt="Preview" className="img-responsive" />
            </div>
          )}

          <label>Facebook:</label>
          <input name="facebook" value={formData.facebook} type="url" className="form-control" onChange={handleChange} />

          <label>LinkedIn:</label>
          <input name="linkedin" value={formData.linkedin} type="url" className="form-control" onChange={handleChange} />

          <label>Instagram:</label>
          <input name="instagram" value={formData.instagram} type="url" className="form-control" onChange={handleChange} />

          <div className="submit-formbtn mt-4">
            <button type="submit" className="default-btn">
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

